// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/scss/app.scss
// module id = 1
// module chunks = 0